// const API_ROOT = 'http://localhost:3018';
const API_ROOT = 'https://app-node.talkmartech.com:3018';
const webPath = 'https://talkmartech.com'




export { API_ROOT, webPath };